import { useSelector } from 'react-redux'
import { RaytebRequests } from '../../_services'
import useFetch from '../../_services/fetch'
import { TextBoxTypeEnum } from '../../enums/TextBoxTypeEnum'
import { Button, RaytebForm, TextBox } from '../../share/Elements'
import { ReducerType } from '../../storeManager/ReducerType'
import { LoginInterface } from '../../Interfaces/LoginInterface'
import { LoadingFit, RaytebModal } from '../../share/Components'
import { toast } from 'react-toastify'
import { useState } from 'react'
import HelTag from 'react-helmet'

const SettingIHIOInsurance = () => {
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  )
  const center = useSelector<ReducerType, CenterViewModel>(
    (state) => state.reducerCenter
  )

  const [showModalVerify, setShowModalVerify] = useState<boolean>(false)
  const loginIHIO = useFetch<LoginIHIOViewModel, LoginIHIOInputModel>({
    request: RaytebRequests.Setting_LoginIHIO_Post({
      token: user?.token,
      centerId: center.id,
    }),
    onSuccess(data) {
      if (data.isTwoStep) {
        setShowModalVerify(true)
      } else toast.success('با موفقیت انجام شد')
    },
  })
  const verifyIHIO = useFetch<unknown, IHIOVerifyLoginInputModel>({
    request: RaytebRequests.Setting_IHIOVerifyLogin_Post({
      token: user?.token,
      centerId: center.id,
    }),
    onSuccess(data) {
      setShowModalVerify(false)
      toast.success('با موفقیت انجام شد')
    },
  })
  return (
    <>
      <HelTag>
        <title>تنظیمات بیمه سلامت</title>
      </HelTag>
      <div className='py-6 px-8 '>
        <h3>بیمه سلامت</h3>
        <br />
        <RaytebForm
          onSubmit={(e) => {
            loginIHIO.reFetch({
              password: e.target['Password'].value,
              userName: e.target['UserName'].value,
            })
          }}
          checkIsRequired={true}
          className='flex flex-col gap-6 relative md:w-96 md:mx-auto'
        >
          <LoadingFit isLoading={loginIHIO.isLoading} />
          <TextBox
            Type={TextBoxTypeEnum.Text}
            innerText='نام کاربری'
            autoFocus={true}
            isRequired={true}
            name='UserName'
            className=''
          />
          <TextBox
            Type={TextBoxTypeEnum.Password}
            innerText='رمز عبور'
            name='Password'
            isRequired={true}
            className=''
          />
          <div className='mt-2 flex justify-center items-center px-20 gap-10 w-full'>
            <Button
              type='submit'
              className='!border-2 border-secondaryLight !bg-secondary !text-white
             !text-xs !w-full h-9 !shadow-lg'
            >
              تایید
            </Button>
          </div>
        </RaytebForm>
      </div>
      <RaytebModal
        title='دریافت کد ارسالی'
        isOpen={showModalVerify}
        hideModal={() => setShowModalVerify(false)}
      >
        <RaytebForm
          className='p-3'
          checkIsRequired={true}
          onSubmit={(e) => {
            verifyIHIO.reFetch({
              code: e.target['Code'].value,
              sessionId: loginIHIO.result?.sessionId!,
            })
          }}
        >
          <div className='px-8 relative'>
            <LoadingFit isLoading={verifyIHIO.isLoading} />
            <TextBox
              Type={TextBoxTypeEnum.Number}
              innerText='کد دریافتی'
              className=''
              name='Code'
            />
          </div>
          <div className='mt-7 flex justify-center items-center px-6 gap-10 w-full'>
            <Button
              type='button'
              onClick={() => {
                setShowModalVerify(false)
              }}
              className='!border-2 border-dangerLight !bg-danger !text-white
             !text-xs !w-full h-9 !shadow-lg'
            >
              انصراف
            </Button>
            <Button
              type='submit'
              className='!border-2 border-secondaryLight !bg-secondary !text-white
             !text-xs !w-full h-9 !shadow-lg'
            >
              تایید
            </Button>
          </div>
        </RaytebForm>
      </RaytebModal>
    </>
  )
}

export default SettingIHIOInsurance
